import { IFormTypesGroupCategoryService } from "../../service/formconfiguration/FormTypesGroupCategoryService";

export default class RemoveFormTypesGroupsInteractor {
  private formTypesGroupCategoryService: IFormTypesGroupCategoryService;

  constructor(formTypesGroupCategoryService) {
    this.formTypesGroupCategoryService = formTypesGroupCategoryService;
  }

  async execute(ids: number[]) {
    await this.formTypesGroupCategoryService.removeFormTypesGroups(ids);
  }
}
